import { AxiosResponse } from 'axios'

import api from './api'

interface IComplaintUpdateData {
  status?: string
  message?: string
  owner?: string
  checkout_status?: string
  checkout_message?: string
  topic_reclassified_id?: string
  step_description?: string
  step?: string
  step_internal?: boolean
  complexity?: string
  criticality?: string
  double_deadline?: boolean
}

interface IComplaintCloseData {
  feedback?: string
}

interface IYearComplexityItem {
  year: number
  complexity: string
  total_completed: string
  total_service_time: number
  sla: number
}

interface IMonthComplexityItem {
  year: number
  month: number
  year_month: string
  complexity: string
  total_completed: string
  total_service_time: number
  sla: string
}

interface IYearComplexityTotal {
  year: number
  totalCompleted: number
  totalServiceTime: number
  sla: number
}

interface IMonthComplexityTotal {
  year: number
  complexity: string
  totalCompleted: number
  totalServiceTime: number
  sla: number
}

interface IComplaintsOpenedByYear {
  year: number
  total_opened: string
}

interface IComplaintsInAnalysisByYear {
  year: number
  total_in_analysis: string
}

interface ISlaSummaryTotals {
  by_year_complexity: IYearComplexityTotal[]
  by_month_complexity: IMonthComplexityTotal[]
  complaints_opened_by_year: IComplaintsOpenedByYear[]
  complaints_in_analysis_by_year: IComplaintsInAnalysisByYear[]
}

// Novo agrupamento: SLA por mês (sem complexidade)
interface IMonthOnlyItem {
  year: number
  month: number
  year_month: string
  total_completed: string
  total_service_time: number
  sla: number | string
}

interface ISlaSummaryResponse {
  by_year_complexity: IYearComplexityItem[]
  by_month_complexity: IMonthComplexityItem[]
  // Novo campo retornado pelo backend para tabela "SLA por Mês"
  by_month?: IMonthOnlyItem[]
  totals: ISlaSummaryTotals
}

export const slaSummary = (startYear: number, endYear: number, owner?: string): Promise<AxiosResponse<ISlaSummaryResponse>> =>
  api.get<ISlaSummaryResponse>('/complaints/sla', { params: { start_year: startYear, end_year: endYear, ...(owner ? { owner } : {}) } })

export const summary = (startDate: string, endDate: string) => api.get('/complaints/summary', { params: { start_date: startDate, end_date: endDate } })

export const getAll = ({ page, pageSize, orderBy, orderDirection, filters, search }: any) => api.get('/complaints', { params: { page, pageSize, orderBy, orderDirection, filters, search } })

export const getComplaintById = (id: string) => api.get(`/complaints/${id}`)

export const getAttachmentById = (id: string, idAttachment: number) => api.get(`/complaints/${id}/attachment/${idAttachment}`)

export const deleteAttachmentById = (id: string, idAttachment: number) => api.delete(`/complaints/${id}/attachment/${idAttachment}`)

export const getTrackingAttachmentById = (id: string, idTracking: number, idAttachment: number) => api.get(`/complaints/${id}/tracking/${idTracking}/attachment/${idAttachment}`)

export const updateComplaintById = (id: string, data: IComplaintUpdateData) => api.put(`/complaints/${id}`, data)

export const storeCommentComplaintById = (id: string, data: IComplaintUpdateData) => api.post(`/complaints/${id}/comments`, data)

export const storeTrackingComplaintById = (id: string, data: any) => api.post(`/complaints/${id}/tracking`, data)

export const uploadFinalReport = (id: string, data: any) => api.put(`/complaints/${id}/attachment`, data)

export const updateTrackingComplaintById = (id: string, idTracking: string, data: any) => api.put(`/complaints/${id}/tracking/${idTracking}`, data)

export const deleteTrackingComplaintById = (id: string, idTracking: string) => api.delete(`/complaints/${id}/tracking/${idTracking}`)

export const getTrackingComplaintById = (id:string, page:number, pageSize:number) => api.get(`/complaints/${id}/tracking`, { params: { page, pageSize } })

export const closeComplaintById = (id: string, data: IComplaintCloseData) => api.put(`/complaints/${id}/closeComplaint`, data)

export const updateStep = (id: string, idStep: number, data: any) => api.put(`/complaints/${id}/step/${idStep}`, data)

export const deleteStep = (id: string, idStep: number) => api.delete(`/complaints/${id}/step/${idStep}`)
